<template>
  <!-- 审批备注 -->
  <div v-if="remarkList.length" class="card">
    <div class="section">
      <div class="section-title">
        <base-section-title id="file" title="审批备注" />
      </div>

      <div class="section-content">
        <div class="p-l-50">
          <el-descriptions v-for="(item, index) in remarkList" :key="index" title="" :column="2" size="medium">
            <el-descriptions-item label="备注" :label-style="{width: '40px'}">{{ item.remark || '' }}</el-descriptions-item>
            <el-descriptions-item label="添加审批备注时间" :label-style="{width: '120px'}">{{ item.remarkTime || '' }}</el-descriptions-item>
          </el-descriptions>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 组件
import BaseSectionTitle from '@/components/common/BaseSectionTitle'

export default {
  components: {
    BaseSectionTitle
  },
  props: {
    remarkList: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {

    }
  },

  computed: {}
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-descriptions {
    .el-descriptions-item {
      vertical-align: top;
    }
  }
}
</style>
